
import { Component, Prop, Vue } from 'vue-property-decorator';
import html2canvas from 'html2canvas';
var QRCode = require('qrcode');
@Component({
  name: 'EventQRDownLoadDialog',
  components: {}
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  dialogVisible!: Boolean;
  @Prop({
    type: Object,
    default: () => ({})
  })
  params!: any;
  @Prop({
    type: String,
    default: 'eventQrId'
  })
  qrCodeid!: String;
   private title='';
   private qrCodeUrl=''
   created() {
     this.createQR();
   }
   private createQR() {
     QRCode.toDataURL(this.params.qrCode)
       .then((url : any) => {
         this.qrCodeUrl = url;
       })
       .catch((err: any) => {
         let msg = err.msg;
       });
   }
   // 下载二维码
   handleDownload() {
     let code: any = document.querySelector('#' + this.qrCodeid);
     let filename = (this.params.event && this.params.event.name) || '巡检事件二维码';
     code.style.width = '310px';
     code.style.height = '380px';
     html2canvas(code as any).then(function(canvas: any) {
       let image = new Image();
       image.src = canvas.toDataURL('image/png');
       let a = document.createElement('a');
       a.appendChild(image);
       a.href = image.src;
       a.download = filename;
       a.click();
     });
     code.style.width = '200px';
     code.style.height = '260px';
   }
   close() {
     this.$emit('close', false);
   }
}
